module.exports = __webpack_public_path__ + "static/media/llp-banner-mobile.26ae523c.webp";